export const environment = {
    production: false,
    mode: "online",
    application: "dumtime",
    apiBaseUrl: "https://233j1vo0v4.execute-api.ap-southeast-1.amazonaws.com/dev-dumtime",
    apikey: "eAiYfUqD5e1xr9oD2XbzS7s6U0mjTlU1a991xwNj",
    firebase: {
        apiKey: "AIzaSyD1FZok9fvTG4z0xov5HhAOBqDdIT62xaA",
        authDomain: "dev-dumtime.firebaseapp.com",
        databaseURL: "https://dev-dumtime-default-rtdb.asia-southeast1.firebasedatabase.app",
        projectId: "dev-dumtime",
        storageBucket: "dev-dumtime.firebasestorage.app",
        messagingSenderId: "974462743520",
        appId: "1:974462743520:web:ddcbc0efdb34af6ce1b185",
        measurementId: "G-RDKQPKW289"
    }

    // production: true,
    // mode: "online",
    // application: "dumtime",
    // apiBaseUrl: "https://e1uirjltph.execute-api.ap-southeast-1.amazonaws.com/prod-dumtime",
    // apikey: "Hpyj7Dl4uU9vpURdhVlqs7BX6Gxl0lDPaIidm5tR",
    // firebase: {
    //     apiKey: "AIzaSyAfsFxI7Umi_OhwQuxUlMgnzfMoARlQ0k0",
    //     authDomain: "prod-dumtime.firebaseapp.com",
    //     databaseURL: "https://prod-dumtime-default-rtdb.asia-southeast1.firebasedatabase.app",
    //     projectId: "prod-dumtime",
    //     storageBucket: "prod-dumtime.firebasestorage.app",
    //     messagingSenderId: "947184699581",
    //     appId: "1:947184699581:web:938c34829055bc9aaa0fd4",
    //     measurementId: "G-VPXPQTRCXG"
    // }
};
